import firebase from "firebase";
import 'firebase/auth'
import 'firebase/messaging'
import 'firebase/database'
import 'firebase/storage'

// Initialize Firebase
const config = {
  apiKey: "AIzaSyA1eUD_hE8oYgkaNrDDY4fEupMElkEe5DA",
  authDomain: "todoakrefactor.firebaseapp.com",
  databaseURL: "https://todoakrefactor.firebaseio.com",
  projectId: "todoakrefactor",
  storageBucket: "todoakrefactor.appspot.com",
  messagingSenderId: "1022589972564",
  appId: "1:1022589972564:web:dcc66cfc67f23a50e0bdc1"
};
export const api_url_fb =
  "https://us-central1-devtravelcar.cloudfunctions.net/api";

// API Key GoogleMaps
export const GOOGLE_API_KEY = "AIzaSyATdY4EzE0mI0MBBzBPb-Y_Qqv5ChGBVdw";
export const api_key_maps = "AIzaSyB5h386bIjur25OED8SylfOCLRNAfKdqyk";
firebase.initializeApp(config);

export const ref = firebase.database().ref();
export const firebaseAuth = firebase.auth;

export const messaging = firebase.messaging();

// Storage
const storage = firebase.storage();
const bucket = storage.ref();
// export const imgRefPerfil = storage;
// export const imgRefCategorias = bucket.child("img_categorias");
// export const imgRefQR = bucket.child("img_qr");
// export const imgRefCliente = bucket.child("fotos_clientes");
export const imgRefPerfil = storage;
export const imgRefCliente = storage.ref("fotos_clientes");


// Cuando necesites usar el messaging necesitas este token:
// BEOjxJ71t8W7trwpuqzr_N43Md_2u5yL-7i4iXb5UhC6HFrrWMVx5hdgPVl3pgPFNieE8M2TBRm4SO9FL_IjrnM
// Este token se pone en la propiedad usePublicVapidKey

// ! Notificaciones PUSH

export const askForPermissioToReceiveNotifications = async () => {
  try {
    const messaging = firebase.messaging();
    await messaging.requestPermission();
    const tokenPush = await messaging.getToken();
    console.log("--Token Push Ususario-- ", tokenPush);
    return tokenPush;
  } catch (error) {
    console.error("--Error Token-- ", error);
  }
};



export const fire = firebase;
